import {
  GET_ANDROID_BANNER_TOP_BANNER,
  GET_ANDROID_RECOMMEND_SOFT,
  GET_ANDROID_RECOMMEND_GROUP_SOFT,
  GET_ANDROID_RECOMMEND_GROUP_SOFT_MORE,
} from '../constants/arecommend';


export const getATopBanner = param => ({
  type: GET_ANDROID_BANNER_TOP_BANNER,
  ...param,
});

export const getARecommendSoft = (param) => ({
  type: GET_ANDROID_RECOMMEND_SOFT,
  ...param,
});

export const getARecommendGroupSoft = param => ({
  type: GET_ANDROID_RECOMMEND_GROUP_SOFT,
  ...param,
});

export const getARecommendGroupSoftMore = param => ({
  type: GET_ANDROID_RECOMMEND_GROUP_SOFT_MORE,
  ...param,
});
